<template>
  <v-btn :class="['main-button-container', `${type}-btn`, {
    'active': active
  }]"
         :disabled="disabled">
      <medium-title>
        <slot/>
      </medium-title>
  </v-btn>
</template>

<script>
import MediumTitle from "@/components/shared/text/MediumTitle.vue";

export default {
  name: "ButtonMain",
  components: { MediumTitle },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
.main-button-container {
  width: fit-content !important;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  cursor: pointer;
  transition: all .3s ease;
  padding: 8px 22px;
  border-radius: 12px;
  box-shadow: none !important;
  border: none;
  background: var(--color-dark-green);
  letter-spacing: normal;
  text-transform: unset;

  &.outline-btn {
    border: 1px solid var(--color-dark-purple);
    background: none;
    &:hover {
      border: 1px solid var(--color-white);
      background: none;
      .medium-title-container {
        color: var(--color-white) !important;
      }
    }
  }
  .medium-title-container {
    transition: all .3s ease;
    font-size: 15px;

  }

  &:hover {
    opacity: 0.7;
  }

  &.active {
    .medium-title-container {
      color: var(--color-white) !important;
    }
  }

}
</style>